// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"l8-z"};